import GUI from "lil-gui"

import EventEmitter from "./EventEmitter.js";

export default class Debug extends EventEmitter {

    constructor() {

        super()
        this.active = window.location.hash === "#debug"

        // GUI

        if (this.active) {
            this.gui = new GUI()
        }
    }
}